import { Platform } from "react-native";
import { useBooleanFlag, getBooleanFlag, FEATURE_FLAGS } from "@src/services/feature-flags/feature-flags";

/**
 * Default used before the flag has been fetched at least once. Native fails
 * open to Auth0 (legacy Django login is being phased out); kept in one place
 * so the reactive and imperative readers below can't disagree on it.
 */
const LEGACY_AUTH_DEFAULT = false;

/**
 * Legacy Auth Hook (reactive)
 *
 * Determines which authentication flow to use based on feature flags.
 * Subscribes to flag store changes so the UI reacts automatically.
 *
 * Amplitude feature flag "legacy_auth":
 *    - true: Use legacy Django API authentication
 *    - false: Use Auth0 authentication
 *
 * Note: Web platform always uses Auth0 (returns false)
 */
export const useLegacyAuth = (): boolean => {
  // Must be called unconditionally (rules of hooks) even though web ignores the result.
  const legacyAuthFlag = useBooleanFlag(FEATURE_FLAGS.LEGACY_AUTH, LEGACY_AUTH_DEFAULT);
  if (Platform.OS === "web") return false;
  return legacyAuthFlag;
};

/**
 * Non-reactive getter for imperative (non-React) code.
 * Reads the current snapshot from the store.
 */
export const getUseLegacyAuth = (): boolean => {
  if (Platform.OS === "web") return false;
  return getBooleanFlag(FEATURE_FLAGS.LEGACY_AUTH, LEGACY_AUTH_DEFAULT);
};
